<script setup>
import { computed } from "vue";
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
);

const props = defineProps({
  labels: {
    type: Array,
    default: () => [],
  },
  incoming: {
    type: Array,
    default: () => [],
  },
  outgoing: {
    type: Array,
    default: () => [],
  },
});

const currencyFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 0,
});

const chartData = computed(() => ({
  labels: props.labels,
  datasets: [
    {
      label: "Cash in",
      data: props.incoming.map((value) => Number(value ?? 0) / 100),
      borderColor: "rgba(16, 185, 129, 0.9)",
      backgroundColor: "rgba(16, 185, 129, 0.15)",
      pointBackgroundColor: "rgba(16, 185, 129, 0.9)",
      tension: 0.35,
      fill: true,
    },
    {
      label: "Cash out",
      data: props.outgoing.map((value) => Number(value ?? 0) / 100),
      borderColor: "rgba(239, 68, 68, 0.85)",
      backgroundColor: "rgba(239, 68, 68, 0.12)",
      pointBackgroundColor: "rgba(239, 68, 68, 0.85)",
      tension: 0.35,
      fill: true,
    },
  ],
}));

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: "#64748b", maxRotation: 0, minRotation: 0 },
    },
    y: {
      beginAtZero: true,
      grid: { color: "rgba(148, 163, 184, 0.25)", drawBorder: false },
      ticks: {
        color: "#64748b",
        callback: (value) => currencyFormatter.format(value),
      },
    },
  },
  plugins: {
    legend: { display: true },
    tooltip: {
      callbacks: {
        label: (context) =>
          `${context.dataset.label}: ${currencyFormatter.format(context.parsed.y ?? 0)}`,
      },
    },
  },
}));
</script>

<template>
  <div class="w-full">
    <Line :data="chartData" :options="chartOptions" class="h-60" />
  </div>
</template>
